import React from 'react'
import { browserHistory } from 'react-router'
import moment from 'moment'
import update from 'immutability-helper';
import { modal } from '../../../core/utilities/modal';
import DropzoneComponent from 'react-dropzone-component';
import { dropZone } from '../../../core/utilities/DropZoneHandler';
import { documents } from '../../../core/controllers/Documents';
import { user } from '../../../core/controllers/user'
import { payable } from '../../../core/controllers/Payable'
import BillActionCenter from '../../../components/Payables/Bill/BillActionCenter'
import VendorSelect from '../../../helpers/Vendor/VendorSelect';

const Attachment = ({attachment, deleteFunc}) => {
    return (
        <attachment key={attachment.id}>
            <div class={attachment.content_type == 'pdf' ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xs-12" : "col-lg-3 col-md-3 col-sm-4 col-xs-6 col-xs-6"}>
                <span class="deleteDocument" onClick={deleteFunc.bind(this, attachment)}><i class="pe-7s-close"></i></span>
                <a href={attachment.url} target="_blank">
                    { attachment.content_type == 'pdf' ? (
                        <object width="100%" height="500" data={attachment.url} type="application/pdf"></object>
                    ) : (
                        <img src={attachment.url} width="100px" height="100px" />
                    )}
                </a>
            </div>
        </attachment>
    );
};

export default class VendorBillEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            vendorBillId : props.vendorBillId,
            newBill: props.newVendorBill,
            sortID: null,
            vendorBill: {
                bill_id: 0,
                title: '',
                description: '',
                hours: 0,
                amount: '',
                due_at: '',
                status: "New",
                created_by: 0,
                p_status: null
            },
            user_info: {
                userType: null
            },
            attachments: null,
        };
    }

    componentDidMount() {
        var self = this;

        jQuery('#bill_due_date').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: 'yy-mm-dd',
            onSelect: function(e) {
                self.handleBillDueDateChange(e);
            }
        });

        dropZone.setup(this, 'vendor_bill', this.state.vendorBillId);
        if (this.props.newVendorBill == false) {
            payable.getVendorBill(this.props.vendorBillId, function(response) {
                response.data.due_at = moment(response.data.due_at).format('Y-MM-D');
                response.data.amount = self.formatAmount(response.data.amount);
                self.setState({
                    vendorBill: response.data,
                    attachments: response.data.attachments
                });
                user.getUserInfo(function(response) {
                    self.setState({
                        user_info: response.data
                    })
                });
            });
        } else {
            user.getUserInfo(function(response) {
                self.setState({
                    user_info: response.data
                })
            });
        }
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
     formatAmount(value) {
        // format money
        var money = parseFloat(value) / 100;
        money = new Intl.NumberFormat('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(money)
        return money;
    }

    handleCreateVendorBill() {
        if(!this.validateData()){
            return;
        }
        const vendorBill = this.state.vendorBill;
        payable.createVendorBill(vendorBill, function(response) {
            modal.resetBackDrop();
            modal.showSuccess("Successfully Created!","A bill has been created!");
            const isFilesAdded = dropZone.isFilesAdded();
            if (isFilesAdded == false) {
                jQuery(".move-on").on('click',function() {
                    browserHistory.goBack();
                });
            }
        });
    }

    handleUpdateVendorBill() {
        if(!this.validateData()){
            return;
        }
        const vendorBill = this.state.vendorBill;
        payable.updateVendorBill(this.props.vendorBillId, vendorBill, function(response) {
            modal.resetBackDrop();
            modal.showSuccess('Successfully Updated!', 'This bill was successfully updated!');
            jQuery(".move-on").on('click',function() {
                browserHistory.goBack();
            });
        });
    }

    handleDeleteVendorBill() {
        if(!this.validateData()){
            return;
        }
        var self = this;
        modal.showDangerModalWithOK("Are you sure?", "This bill will be deleted.", "Yes, Delete!");
		jQuery(".move-on").on('click',function() {
            payable.deleteVendorBill(self.props.vendorBillId, function(response) {
                modal.resetBackDrop();
                modal.showSuccess('Successfully deleted!', 'This bill was successfully deleted!');
                jQuery(".move-on").on('click',function() {
                    browserHistory.goBack();
                });
            });
        });
    }

    handleDeleteDocument(attachment) {
        var self = this;
        documents.deleteDocument(attachment.id, function() {
            payable.getVendorBill(self.props.vendorBillId, function(response) {
                response.data.due_at = moment(response.data.due_at).format('Y-MM-D');
                response.data.amount = self.formatAmount(response.data.amount);
                self.setState({
                    vendorBill: response.data,
                    attachments: response.data.attachments
                });
            });
        });
    }

    renderAttachments(attachments) {
        var self = this;
        if (attachments !== null) {
            if(attachments.length > 0) {
                var attachmentsLength = attachments.length
                for (var i = 0; i < attachmentsLength; i++) {
                    if (attachments[i].content_type == "pdf") {
                        var temp = attachments[i]
                        attachments.splice(i, 1);
                        attachments.push(temp)
                    }
                }
                return attachments.map((attachment, index) => (
                    <Attachment key={index} attachment={attachment} deleteFunc={self.handleDeleteDocument.bind(self)}/>
                ));
            }
        }
    }

    triggerUpload(bill_id, type) {
        var self = this;
        const isFilesAdded = dropZone.isFilesAdded();
        if (isFilesAdded == false) {
            modal.showInfo("There is no pending file to upload!", "warning", "top", "center");
            return;
        }

        if(bill_id != 0 && bill_id != "new") {
            type = 'vendor_bill';
            dropZone.setup(this, 'vendor_bill', bill_id, true);
        }

        dropZone.upload(type, function() {
            payable.getVendorBill(self.props.vendorBillId, function(response) {
                response.data.due_at = moment(response.data.due_at).format('Y-MM-D');
                response.data.amount = self.formatAmount(response.data.amount);
                modal.showInfo("Document uploaded!", "success", "top", "center");
                self.setState({
                    vendorBill: response.data,
                    attachments: response.data.attachments
                });
            });
        });
    }

    handleBillTitleChange(e){
        this.setState({
            vendorBill: update(this.state.vendorBill, {
                title: {$set: e.target.value}
            })
        });
    }

    handleBillDescriptionChange(e){
        this.setState({
            vendorBill: update(this.state.vendorBill, {
                description: {$set: e.target.value}
            })
        });
    }

    handleBillHoursChange(e){
        this.setState({
            vendorBill: update(this.state.vendorBill, {
                hours: {$set: e.target.value}
            })
        });
    }

    handleBillAmountChange(e){
        this.setState({
            vendorBill: update(this.state.vendorBill, {
                amount: {$set: e.target.value}
            })
        });
    }

    handleBillDueDateChange(value){
        this.setState({
            vendorBill: update(this.state.vendorBill, {
                due_at: {$set: value}
            })
        });
    }

    handleBillStatusChange(e){
        this.setState({
            vendorBill: update(this.state.vendorBill, {
                status: {$set: e.target.value}
            })
        });
    }

    handleVendorChange(e) {
        this.setState({
            vendorBill: update(this.state.vendorBill, {
                created_by: {$set: e.target.value}
            })
        });
    }

    validateData() {
        const vendorBill = this.state.vendorBill;
        const filesAdded = dropZone.isFilesAdded();
        const uploadSuccess = dropZone.isUploadSuccess();
        const amount = vendorBill.amount.replace(/,/g, '');
        const userType = this.state.user_info.user_type;

        if(filesAdded == true && uploadSuccess == false) {
            modal.showInfo("You have pending files that need to be uploaded!", "warning", "top", "center");
            return false;
        }

        if (!vendorBill.title || vendorBill.title.length == 0) {
            modal.showInfo("You need to enter the title of this bill.", "warning", "top", "center");
            return false;
        }

        if (!vendorBill.description || vendorBill.description.length == 0) {
            modal.showInfo("You need to enter the description of this bill.", "warning", "top", "center");
            return false;
        }

        if (vendorBill.hours <= 0) { 
            modal.showInfo("You need to enter the total hours worked of this bill.", "warning", "top", "center");
            return false;
        }

        if (amount === undefined || amount <= 0) {
            modal.showInfo("You need to enter the total amount of this bill.", "warning", "top", "center");
            return false;
        } else if (isNaN(amount)) {
            modal.showInfo("Please enter a valid bill amount.", "warning", "top", "center");
            return false;
        }

        if (!vendorBill.due_at || vendorBill.due_at.length == 0) {
            modal.showInfo("You need to enter the bill due date.", "warning", "top", "center");
            return false;
        }

        if (userType != 'vendor') {
            if (vendorBill.created_by == 0 || vendorBill.created_by == '0') {
                modal.showInfo("Which vendor is this bill for?", "warning", "top", "center");
                return false;
            }
        }

        return true;
    }

    render(){
        const newBill = this.state.newBill;
        const billTitle = this.state.vendorBill.title;
        const billDescription = this.state.vendorBill.description;
        const billHours = this.state.vendorBill.hours;
        const billAmount = this.state.vendorBill.amount;
        const billDueDate = this.state.vendorBill.due_at;
        const billStatus = this.state.vendorBill.status;
        const vendorId = this.state.vendorBill.created_by;
        const attachments = this.renderAttachments(this.state.attachments);
        const userType = this.state.user_info.user_type;
        const billId = this.state.vendorBillId;
        const paymentStatus = this.state.vendorBill.p_status;
        var statusDisabled = '';
        if (userType == 'vendor') {
            statusDisabled = 'true';
        }
        return (
        <div>
            <div class="row blue-bottom-margin">
                <div class="row">
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            <span class="sub-page-header-title">{newBill ? "Add a Bill" : billTitle}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-8 col-sm-12 col-xs-12">
                    <div class="col-md-12 card">
                        <div class="header">
                            <h4 class="title">Bill Information</h4>
                            <p class="category"></p>
                        </div>
                        <div class="content">
                            <form>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label>Title</label>
                                            <input type="text" class="form-control" placeholder="Title" value={billTitle} onChange={this.handleBillTitleChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label>Description</label>
                                            <input type="text" class="form-control" placeholder="Description" value={billDescription} onChange={this.handleBillDescriptionChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label>Hours</label>
                                            <input type="number" class="form-control" placeholder="Hours" value={billHours} onChange={this.handleBillHoursChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label>Amount</label>
                                            <input type="text" class="form-control" placeholder="Amount" value={billAmount} onChange={this.handleBillAmountChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label>Due Date</label>
                                            <input type="text" class="form-control" placeholder="Due Date" id="bill_due_date" value={billDueDate} onChange={this.handleBillDueDateChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                        <div class="form-group">
                                            <label>Status</label>
                                            <select class="form-control" value={billStatus} onChange={this.handleBillStatusChange.bind(this)} disabled={statusDisabled}>
                                                <option value="SUBMITTED">New</option>
                                                <option value="IN_REVIEW">In Review</option>
                                                <option value="APPROVED">Approved</option>
                                                <option value="DECLINED">Declined</option>
                                                <option value="PAID">Paid</option>
                                                <option value="CANCELLED">Cancelled</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {userType != 'vendor' && (
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label>Who does this bill belong to?</label>
                                            <VendorSelect columnSize={0} sortID={vendorId} title="" onChange={this.handleVendorChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-12 col-xs-12">
                    <BillActionCenter amount={billAmount} billId={billId} paymentStatus={paymentStatus} userType={userType}/>
                    <div class="card">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="header">
                                    <h4 class="title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-document-plus"></i></span> Documents</h4>
                                    <p class="category"></p>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="content">
                                        <p class="dropzone-subtitle">Upload relavant documents</p>
                                        { attachments == null ? (
                                            null
                                        ) : (
                                            attachments
                                        )}
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="content">
                                        { newBill == false && this.state.dropZoneSetup !== undefined && (
                                            <div style={{textAlign: "center"}}>
                                                <DropzoneComponent config={this.state.dropZoneConfig}
                                                    eventHandlers={this.state.dropZoneEventHandlers}
                                                    djsConfig={this.state.dropZoneJSConfig} />
                                                <button type="button" class="btn btn-info btn-secondary btn-fill dropZone-upload" autoComplete="off" onClick={this.triggerUpload.bind(this, billId, "new_vendor_bill")}>Upload</button>
                                            </div>
                                        )}
                                        { newBill == true && (
                                            <div style={{textAlign: "center"}}>
                                                <p>Once you create this bill, you'll be able to upload attachments.</p>
                                            </div>
                                        )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row blue-bottom">
                <div class="blue-bottom-center-align">
                    {newBill ? (
                    <div>
                        <button type="button" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.handleCreateVendorBill.bind(this)}>
                        Create Bill
                        </button>
                    </div>
                    ) : (
                    <div>
                        <div class="col-md-6 col-sm-6 col-xs-12 blue-bottom-btn-right-push">
                            <button type="button" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.handleDeleteVendorBill.bind(this)}>
                            Delete Bill
                            </button>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                            <button type="button" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.handleUpdateVendorBill.bind(this)}>
                            Update Bill
                            </button>
                        </div>
                    </div>
                    )}
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        )
    }
};



// WEBPACK FOOTER //
// app/components/Payables/Bill/VendorBillEdit.jsx